import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IhmConfigurationService } from '../ihm-configuration/ihm-configuration.service';
import { AuthOkta } from './interfaces/auth.interface';
import { OKTA_CONFIG, OktaAuthModule, OktaCallbackComponent } from '@okta/okta-angular';
import { ModuleWithProviders } from '@angular/compiler/src/core';

export function initConfig(configService: IhmConfigurationService<AuthOkta>): () => Promise<void> {
  return (): Promise<void> => configService.initialize();
}

export function initOktaAuth(settingsService: IhmConfigurationService<AuthOkta>) {
  const dataConfiguration = settingsService.get();
  return {
    issuer: `${dataConfiguration.okta.config.issuer}`,
    redirectUri: `${dataConfiguration.okta.config.redirectUri}`,
    clientId: `${dataConfiguration.okta.config.clientId}`,
    scope: `${dataConfiguration.okta.config.scope}`
  };
}

// @dynamic
@NgModule({
  imports: [OktaAuthModule]
})
export class IhmOktaModule {
  public static initAuth(): ModuleWithProviders {
    return {
      ngModule: IhmOktaModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: initConfig,
          multi: true,
          deps: [IhmConfigurationService]
        },
        {
          provide: OKTA_CONFIG,
          useFactory: initOktaAuth,
          deps: [IhmConfigurationService]
        }
      ]
    };
  }
}
